module.exports = __webpack_public_path__ + "static/media/oculus.4cf1c28b.png";